import { Header, Text, Image } from "grommet";

const AppBar = (props) => (
    <Header
        //width={{ max: '53rem', min:'90%', width:'94%' }}
        background="brand"
        pad={{ left: "medium", right: "small", vertical: "small" }}
        elevation="medium"
        style={{
            borderRadius: '5px',
            border: '1px solid rgba(255, 255, 255, 0.05)',
            background: 'linear-gradient(180deg, rgba(74, 79, 107, 0.30) 0%, rgba(35, 37, 50, 0.50) 100%)',
            boxShadow: '0px 25px 50px 0px rgba(1, 5, 22, 0.30)',
            backdropFilter: 'backdrop-filter: blur(50px)'
        }}
        {...props}
    />
);

const HeaderSection = ({ isInternal, isSharing }) => {
    return (
        <AppBar width={{ max: '51.3rem', width: "94%" }} margin='0.5rem' zIndex={2}>
            <Text color='white' size="large">{isInternal && isSharing ? "TC Dropbox Sharing" : "SAIL Traffic Light Pricing"}</Text>
            <Image margin={{ 'top': 'xsmall', right: 'small' }} height={'30rem'} src={''} />
        </AppBar>
    );
}

export { HeaderSection }